import { render, staticRenderFns } from "./CreditsInfo.vue?vue&type=template&id=8b15e130&scoped=true"
import script from "./CreditsInfo.vue?vue&type=script&lang=ts"
export * from "./CreditsInfo.vue?vue&type=script&lang=ts"
import style0 from "./CreditsInfo.vue?vue&type=style&index=0&id=8b15e130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b15e130",
  null
  
)

export default component.exports